import { gql, useMutation } from '@apollo/client';
import { DEFAULT_RESPONSE_ERROR_MESSAGE } from 'modules/campaigns/lib/constants';
import { maybeRestErrorMessage } from 'modules/campaigns/editor/utils';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import { useDispatch } from 'react-redux';

export const toggleWebhookMutation = gql`
  mutation updateCampaignAlertsWebhook($id: Long!, $enabled: Boolean!) {
    updateCampaignAlertsWebhook(id: $id, enabled: $enabled) {
      id
      name
      enabled
    }
  }
`;

export const useToggleWebhook = () => {
  const dispatch = useDispatch();

  const [toggleWebhook, { data, loading, error }] = useMutation(toggleWebhookMutation, {
    onCompleted: (response) => {
      const { name, enabled } = response?.updateCampaignAlertsWebhook;
      if (enabled) {
        dispatch(addPositiveToast(`Alerts to ${name} have been enabled.`));
      } else {
        dispatch(addPositiveToast(`Alerts to ${name} have been disabled.`));
      }
    },
    onError: (e) => {
      const errorResponseMessage = maybeRestErrorMessage(e) || DEFAULT_RESPONSE_ERROR_MESSAGE;
      const errorMessage = `Cannot update webhook: ${errorResponseMessage}`;
      dispatch(addNegativeToastWithErrorId(errorMessage, 'useToggleWebhook', e));
    },
  });

  return {
    toggleWebhook,
    data,
    loading,
    errorMessage: error?.message || data?.updateCampaignAlertsWebhook?.failure?.message,
  };
};
